import { Check } from "lucide-react";
import { motion } from "framer-motion";
import { screenshots } from "../assets/screenshots";
import { DeviceMockup } from "../components/DeviceMockup";
import type { LandingContent } from "../content/types";

type CameraExperienceSectionProps = {
  content: LandingContent["camera"];
};

export function CameraExperienceSection({ content }: CameraExperienceSectionProps) {
  return (
    <section className="section-pad section-gradient" id="capabilities">
      <div className="site-container split-grid">
        <div className="section-copy">
          <h2>{content.title}</h2>
          <p>{content.body}</p>
          <ul className="check-list">
            {content.points.map((point) => (
              <li key={point}>
                <Check size={18} aria-hidden="true" />
                {point}
              </li>
            ))}
          </ul>
        </div>
        <motion.div className="device-stage" whileInView={{ opacity: [0, 1], y: [20, 0] }} viewport={{ once: true, margin: "-80px" }}>
          <DeviceMockup src={screenshots.camera} alt="Prismark camera viewfinder with shooting controls" />
        </motion.div>
      </div>
    </section>
  );
}
